import { render, staticRenderFns } from "./approvalDia.vue?vue&type=template&id=b87392a0&scoped=true&"
import script from "./approvalDia.vue?vue&type=script&lang=js&"
export * from "./approvalDia.vue?vue&type=script&lang=js&"
import style0 from "./approvalDia.vue?vue&type=style&index=0&id=b87392a0&lang=scss&scoped=true&"
import style1 from "./approvalDia.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87392a0",
  null
  
)

export default component.exports